import React from 'react';
import { Sparkles, Truck, CreditCard } from 'lucide-react';
import { TRAVEL_FEE } from '../../utils/mock';

const InfoBanners = () => {
  return (
    <>
      {/* First-Time Customer Discount Banner */}
      <div className="mb-4 md:mb-6 p-4 md:p-5 bg-gradient-to-r from-green-900/40 to-emerald-900/40 border-2 border-green-500/60 rounded-lg">
        <div className="flex items-start space-x-3">
          <Sparkles className="w-6 h-6 text-green-400 mt-0.5 flex-shrink-0 animate-pulse-slow" />
          <div>
            <h3 className="text-green-400 font-bold text-lg mb-1">🎉 First-Time Customer Special!</h3>
            <p className="text-gray-200 text-base font-semibold mb-2">
              Save $30 on your first detail service with us!
            </p>
            <p className="text-gray-300 text-sm">
              Discount automatically applied at checkout for new customers. Valid on any service package. 
              This is our way of welcoming you to Mobile Shine!
            </p>
          </div>
        </div>
      </div>
      
      {/* Travel Fee Notice */}
      <div className="mb-6 p-4 bg-blue-900/20 border border-blue-500/50 rounded-lg">
        <div className="flex items-start space-x-3">
          <Truck className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0" />
          <div>
            <h3 className="text-blue-400 font-semibold mb-1">Travel Fee Notice</h3>
            <p className="text-gray-300 text-sm">
              <span className="font-semibold text-green-400">✓ FREE</span> travel within 20 km radius of Willoughby, Langley, BC. 
              Extended coverage available with distance-based surcharge. Travel fees (if applicable) will be confirmed before your appointment.
            </p>
          </div>
        </div>
      </div>

      {/* Payment Options Notice */}
      <div className="mb-6 p-5 bg-gradient-to-r from-purple-900/30 to-purple-800/20 border-2 border-purple-500/50 rounded-lg">
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-purple-600/30 border border-purple-500/50 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <CreditCard className="w-4 h-4 text-purple-300" />
          </div>
          <div>
            <h3 className="text-purple-300 font-bold text-lg mb-1">💳 Flexible Payment Options</h3>
            <p className="text-gray-200 text-base font-semibold mb-1">
              Choose how you want to pay!
            </p>
            <p className="text-gray-300 text-sm">
              Pay full amount now, pay a 30% deposit, or book now and pay after service. 
              All payments are securely processed through Square. Choose your preferred option at checkout.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default InfoBanners;
